module.exports = __webpack_public_path__ + "static/banner-one-main-img-c639592ec6df0b03477125e486bf6fd0.png";